var map = {
	"./0.png": "aKT8",
	"./1.png": "AdiL",
	"./2.png": "93KF",
	"./3.png": "DVX7",
	"./4.png": "9GT9",
	"./5.png": "kxFG",
	"./6.png": "0eFo",
	"./bg.png": "RBA5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XA1F";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/card ^\.\/.*$
// module id = XA1F
// module chunks = 2